import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GET_BOSS_FEEDBACK_POST } from "../../../../api/boss-feedback";
import BossBottomTab from "../../components/boss-bottom-tab";

type BossFeedbackPost = {
  id: string;
  content: string;
  authorName: string;
  authorId: number;
  status: string;
  createdAt: string;
  updatedAt: string;
  replyCount: number;
  replies: Array<{
    id: string;
    content: string;
    isAdmin: boolean;
    createdAt: string;
    updatedAt?: string;
  }>;
};

const BossFeedbackDetail: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { data, loading } = useQuery(GET_BOSS_FEEDBACK_POST, {
    variables: { id: id ?? "" },
    skip: !id,
  });

  const post: BossFeedbackPost | undefined = data?.bossFeedbackPost;

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 pb-[120px]">
        <div className="px-4 py-5 pt-16">
          <button
            className="text-sm mb-3"
            onClick={() => navigate("/boss/feedback")}
          >
            ← 뒤로
          </button>
          <div className="text-sm text-gray-500">로딩 중...</div>
        </div>
        <BossBottomTab />
      </div>
    );
  }

  if (!post) {
    return (
      <div className="min-h-screen bg-gray-100 pb-[120px]">
        <div className="px-4 py-5 pt-16">
          <button
            className="text-sm mb-3"
            onClick={() => navigate("/boss/feedback")}
          >
            ← 뒤로
          </button>
          <div className="text-sm text-gray-500">
            게시글을 찾을 수 없습니다.
          </div>
        </div>
        <BossBottomTab />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 pb-[120px]">
      <div className="px-4 py-5 pt-16">
        <button
          className="text-sm mb-3"
          onClick={() => navigate("/boss/feedback")}
        >
          ← 뒤로
        </button>
        <div className="text-xs text-gray-500 mb-1">
          {new Date(post.createdAt).toLocaleString()}
        </div>
        <p className="text-sm mt-3 whitespace-pre-wrap bg-white border border-gray-200 rounded-lg p-4">
          {post.content}
        </p>

        <div className="mt-6">
          <h2 className="text-sm font-medium mb-2">
            답변 {post.replies?.length ?? 0}
          </h2>
          {!post.replies?.length ? (
            <div className="text-sm text-gray-500">아직 답변이 없습니다.</div>
          ) : (
            <ul className="space-y-3">
              {post.replies.map((r) => (
                <li
                  key={r.id}
                  className={`border rounded-md p-3 ${
                    r.isAdmin
                      ? "bg-[#F4F5F7] border-[#1562fc]"
                      : "bg-white border-[#F4F5F7]"
                  }`}
                >
                  <div className="text-xs text-gray-500">
                    {r.isAdmin ? (
                      <span className="text-[#1562fc] font-medium">운영자</span>
                    ) : (
                      "사장님"
                    )}{" "}
                    · {new Date(r.createdAt).toLocaleString()}
                  </div>
                  <div className="text-sm mt-1 whitespace-pre-wrap">
                    {r.content}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <BossBottomTab />
    </div>
  );
};

export default BossFeedbackDetail;
